import { createApp } from 'vue';
import App from './App.vue';
import 'vuetify/styles';
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import { createRouter, createWebHistory } from 'vue-router';
import PrincipalPage from './Vues/PrincipalPage.vue';
import { TroisJSVuePlugin } from 'troisjs';


const router = createRouter({
    history: createWebHistory(),
    routes: [
      { path : '/', component : PrincipalPage}, 
      { path: '/:pathMatch(.*)*', component: App},
    ],
});


const vuetifyOptions = {
    icons: {
      iconfont: 'fa',
    },
};

const darkTheme = {
    dark: true,
    colors: {
      primary: '#5B7EEF',
      secondary: '#1B253A',
      accent: '#B3CCFF',
      error: '#E35264',
      info: '#52BDE3',
      success: '#4CCE7E',
      warning: '#E39052',
    },
  };


const vuetify = createVuetify({
    theme: {
      defaultTheme: 'darkTheme',
      themes: {
        darkTheme,
      },
    },
    components,
    directives,
    ...vuetifyOptions,
  });


const app = createApp(App);

app.use(router);
app.use(vuetify);
app.use(TroisJSVuePlugin);

app.mount('#app');



